/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Divider, Grid, Typography, useMediaQuery } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
//
import { BtnAddForm, BtnBack, BtnHome, BtnSend } from 'components/Common/Button';
import { AlertMsgTh, AlertTitleTh, AlertTitle, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import CpnDataRequest from '../ComponentVOC/CpnDataRequest';
import CpnTypeRequestComplaint from '../ComponentVOC/CpnTypeRequestComplaint';
import CpnResponPerson from '../ComponentVOC/CpnResponPerson';
import CpnStatusVOC from '../ComponentVOC/CpnStatusVOC';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import CpnPopUpMap from '../ComponentVOC/CpnPopUpMap';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import moment from 'moment';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { BiEdit } from "react-icons/bi";
import VerticalStepper from 'components/Stepper/VerticalStepper';
import CpnNote from '../ComponentVOC/CpnNote';
import CpnDataClassifyVOC from '../ComponentVOC/CpnDataClassifyVOC';
import CpnClassifyIssue from '../ComponentVOC/CpnClassifyIssue';
import CpnTypeRequest from '../ComponentVOC/CpnTypeRequest';
import CpnAlertEmail from '../ComponentVOC/CpnAlertEmail';
import CardBox from 'components/CardBox/CardBox';
import { AiFillWechat } from "react-icons/ai";
import secureLocalStorage from 'react-secure-storage';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import ModalWorkflowHistory from '../ComponentVOC/ModalWorkflowHistory';

const PageClassifyIssue = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout1300 = useMediaQuery('(min-width:1300px)');

    //useState
    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": [],
        "lstRoleUser": [],
    })
    const [schemaObj, setSchemaObj] = useState({} as any);
    const [sVOCFormID, setsVOCFormID] = useState(location?.state ? location.state["sVOCFormID"] : null)
    const [sMode, setsMode] = useState("classify")  //Edit, View, Super
    const [sStatusForm, setsStatusForm] = useState(null)
    const [sCustomer, setsCustomer] = useState("")
    const [nAlertCount, setnAlertCount] = useState(0)
    const [IsOpenModalWorkFlowHis, setIsOpenModalWorkFlowHis] = useState(false)

    const [sRefVOCCode, setsRefVOCCode] = useState("")
    const [nStatusID, setnStatusID] = useState(0)
    const [nHistoryStatusID, setnHistoryStatusID] = useState(0)
    const [DataRowResolve, setDataRowResolve] = useState([] as any)       //List Note

    const [isInputTelRequire, setisInputTelRequire] = useState(false)
    const [IsRequireObjInprogress, setIsRequireObjInprogress] = useState(false)
    const [IsRequireOtherInprogress, setIsRequireOtherInprogress] = useState(false)
    const [sTypeClassifyIssue, setsTypeClassifyIssue] = useState("")  //C:Complain,R:Request
    const [BAold, setBAold] = useState("")
    const [BACurrent, setBACurrent] = useState("")
    const [UserLoginBA, setUserLoginBA] = useState([] as any)
    const [nSelectAddrType, setnSelectAddrType] = useState(0)

    const [arrFileResolve, setarrFileResolve] = useState([] as any)
    const [IsOtherRequest, setIsOtherRequest] = useState(false)
    const [IsAllowEmailAlert, setIsAllowEmailAlert] = useState(false)
    const [IsReferVOC, setIsReferVOC] = useState(false)
    const [IsRoleDM, setIsRoleDM] = useState(false)


    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    //#region  state component CpnDataRequest
    const onClearFile = useRef(null);
    const onClearFileResolve = useRef(null);

    const [arrAttachment, setarrAttachment] = useState([] as any)
    const [arrFileNote, setarrFileNote] = useState([] as any)

    //#endregion

    //#region  state component CpnTypeRequestComplaint
    const [Option, setOption] = useState({
        lstBA: [],
        lstCompany: [],
        lstCompanyAddress: [],
        lstVOCType: [],
        lstJobType: [],
        lstVOCService: [],
        lstTel: [],
        lstContactType: [],
        lstTypeResolve: [],
        lstTypeRequest: [],
        lstOutPTT: [],
        lstTypeCompliant: [],
        lstTypeResponPerson: [],
        lstResponPerson: [],
        lstStatus: [],
    })
    //#endregion


    const [IsCheckTel, setIsCheckTel] = useState(false)
    const [IsOtherVOCService, setIsOtherVOCService] = useState(false)


    const [IsOtherExternalPTT, setIsOtherExternalPTT] = useState(false)
    const [sTypeResponPerson, setsTypeResponPerson] = useState("22")
    const [sResponPerson, setsResponPerson] = useState('25')

    //#endregion


    //#region  Form
    let objSchema = {
        //1
        sJobCode: yupFormSchemas.object("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        sReferVOCFormCode: yupFormSchemas.object("เลขที่ใบแจ้งอ้างอิง", { required: false }),
        oCustomer: yupFormSchemas.object("ลูกค้า", { required: false }),
        oBA: yupFormSchemas.object("กลุ่มตลาด", { required: true }),

        oCompany: yupFormSchemas.object("บริษัท", { required: false }),
        oAddress: yupFormSchemas.object("ที่อยู่/สถานที่เกิดเหตุ", { required: false }),
        sAddress: yupFormSchemas.string("ที่อยู่/สถานที่เกิดเหตุ", { required: false }),

        oVOCType: yupFormSchemas.object("ประเภท", { required: true }),
        oVOCService: yupFormSchemas.object("บริการที่ต้องการ / ปัญหาที่พบ", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : true }),
        sOtherVOCService: yupFormSchemas.string("บริการที่ต้องการ / ปัญหาที่พบ (อื่นๆ)", { required: IsOtherVOCService }),

        sDetail: yupFormSchemas.string("รายละเอียด", { required: false }),
        oTel: yupFormSchemas.object("หมายเลขโทรศัพท์", { required: false }),
        sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: isInputTelRequire }),

        oNoticeChannel: yupFormSchemas.object("ช่องทางที่รับแจ้ง", { required: false }),
        sDateIssue: yupFormSchemas.string("วันที่แจ้ง", { required: false }),
        sTimeIssue: yupFormSchemas.string("เวลาที่แจ้ง", { required: false }),
        sNoticeEmail: yupFormSchemas.string("ส่งอีเมลแจ้งเตือนลูกค้า", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : true }),
        //2
        oTypeJobType: yupFormSchemas.object("ประเภทการแจ้งปัญหา", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : true }),

        //3
        //R
        oTypeRequest: yupFormSchemas.object("ประเภทข้อร้องขอ", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : sTypeClassifyIssue === "R" }),
        sRequestTypeOther: yupFormSchemas.string("ประเภทข้อร้องขอ (อื่นๆ)", { required: IsOtherRequest }),
        //C
        oTypeResolve: yupFormSchemas.object("ประเภทสำหรับแก้ไขปัญหา", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : sTypeClassifyIssue === "C" }),
        oReqInprogress: yupFormSchemas.object("ข้อร้องเรียนเกี่ยวกับการดำเนินงาน", { required: IsRequireObjInprogress }),
        sReqInprogress: yupFormSchemas.string("ข้อร้องเรียนเกี่ยวกับการดำเนินงาน (อื่นๆ)", { required: IsRequireOtherInprogress }),
        oTypeCompliant: yupFormSchemas.object("GBU Compliant Type", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : sTypeClassifyIssue === "C" }),
        //4
        sTypeResponPerson: yupFormSchemas.string("ประเภทผู้รับผิดชอบ", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : (sTypeClassifyIssue === "C" || sTypeClassifyIssue === "R") }),
        sResponPerson: yupFormSchemas.string("ผู้รับผิดชอบ", { required: !UserLoginBA.includes(parseInt(BACurrent)) ? false : (sTypeClassifyIssue === "C" || sTypeClassifyIssue === "R") }),
        oAutoUnitInGBU: yupFormSchemas.object("หน่วยงาน", { required: sTypeResponPerson === "22" && sResponPerson === "25" ? true : false }),
        oAutoEmpInGBU: yupFormSchemas.object("ผู้รับผิดชอบแก้ไข", { required: ([1, 2].includes(nStatusID) && sResponPerson === "26") && sTypeResponPerson === "22" ? true : false }),   //ผจ.ส่วน
        oAutoUnitInPTT: yupFormSchemas.object("หน่วยงาน", { required: sTypeResponPerson === "23" && sResponPerson === "25" ? true : false }),
        oAutoEmpInPTT: yupFormSchemas.object("ผู้รับผิดชอบแก้ไข", { required: ([1, 2].includes(nStatusID) && sResponPerson === "26") && sTypeResponPerson === "23" ? true : false }),     //ผจ.ส่วน
        oUnitExternalPTT: yupFormSchemas.object("บุคคล", { required: sTypeResponPerson === "24" ? true : false }),
        sExternalPTT: yupFormSchemas.string("หน่วยงาน (อื่นๆ)", { required: IsOtherExternalPTT }),

        oStatus: yupFormSchemas.object("สถานะ", { required: false }),
        sResolveDetail: yupFormSchemas.string("รายละเอียดการแก้ไข", { required: ["15", "16"].includes(sStatusForm) ? true : false }),


    }

    const schema = yup.object().shape(Object.assign(objSchema, schemaObj));
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    //#region  useEffect
    useEffect(() => {
        GetUserData();
        const urlParams = new URLSearchParams(location.search);
        const sParamVOCFormID = urlParams.get("strMail");
        let sParamVOCID = "";
        let IsFromMail = false;
        if((location.state && location.state["sVOCFormID"]))
        {
            sParamVOCID = location?.state["sVOCFormID"];
            setsVOCFormID(location?.state["sVOCFormID"])
            IsFromMail = false;
        }
        else if(sParamVOCFormID)
        {
            sParamVOCID = sParamVOCFormID;
            setsVOCFormID(sParamVOCFormID)
            IsFromMail = true;
        }

        if (sParamVOCID != "") {
            //Get Data for update
            secureLocalStorage.removeItem("LinkTo");
            secureLocalStorage.removeItem("sUserType");
            GetDataVOCID(sParamVOCID);
        }

    }, [location?.state])

    useEffect(() => {
        if (arrFileResolve.length == 1) {

            onAddResolve2Table()
        }
    }, [arrFileResolve])

    //#endregion

    //#region Get data Form API
    const GetUserData = async () => {
        AxiosGet("User/GetUserData", { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                let lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                setUserLoginBA(lstIntBA || [])
                setDataUser({
                    "nUserID": res.result.nUserID || "",
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                    "lstRoleUser": res.result.lstRole || []
                });
            })
        })
    };

    const onSaveFlowRead = async (sParamVOCFormID) => {
        let oParam = {
            "sVOCFormID": sParamVOCFormID,
            "sMode": "R",
        }
        if (sParamVOCFormID != "") {
            await AxiosPost(`VOC/SaveVOCFormData`, oParam, (res) => {
                ResultAPI(res, null, () => {
                })
            }, null, null)
        }
    }

    const GetOptiontEditFormVOCAll = async (Result) => {
        BlockUI();

        let oOptionVOC = {
            lstBA: [],
            lstCompany: [],
            lstCompanyAddress: [],
            lstVOCType: [],
            lstJobType: [],
            lstVOCService: [],
            lstTel: [],
            lstContactType: [],
            lstOutPTT: [],
            lstTypeResolve: [],
            lstTypeRequest: [],
            lstTypeCompliant: [],
            lstReqInprogress: [],
            lstTypeResponPerson: [],
            lstResponPerson: [],
            lstStatus: [],
        };

        if (Result?.objCustomer && Result?.objCustomer?.value) {
            AxiosGet(`User/GetUserTelById`, { "nUserID": Result?.objCustomer?.value, "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstTel: res.result?.data || [] }
                })
            });

            // nBAID //follow login
            AxiosPost(`Company/SearchCompany`, { "nBAID": DataUser.lstUserBA, "sLanguage": "th", "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstCompany: res.result?.data || [] }
                })
            });

        }

        if (Result.objOwnerBA && Result?.objOwnerBA?.value) {
            if (Result?.objVOCType) {
                let nVOCTypeID = Result.objVOCType ? parseInt(Result?.objVOCType?.value) : 0
                let nBAID = parseInt(Result?.objOwnerBA?.value) ?? 0
                AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID, "IsAdd": false }, (res) => {
                    ResultAPI(res, null, () => {
                        oOptionVOC = { ...oOptionVOC, lstVOCService: res.result?.data || [] }
                    })
                });
            }
        }

        if (Result.objCompany && Result?.objCompany?.value) {
            AxiosGet(`Company/GetCompanyAddress`, { "nUserID": parseInt(Result?.objCustomer?.value), "nCompanyID": Result?.objCompany?.value, "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstCompanyAddress: res.result?.data || [] }
                })
            });

            // if (Result?.objCustomer && Result?.objCustomer?.value) {
            //     AxiosGet(`BAService/GetBA`, { "nCompanyID": Result?.objCompany?.value, "nCustomerID": Result?.objCustomer?.value, "IsSuggestion": false }, (res) => {
            //         ResultAPI(res, null, () => {
            //             oOptionVOC = { ...oOptionVOC, lstBA: res.result?.data || [] }

            //             let lstBA = res.result?.data || [];
            //             if (lstBA.length === 1) {
            //                 form.setValue("oBA", res.result?.data[0] || {})
            //                 setBACurrent(res.result?.data[0].value ?? "")
            //             }
            //             else if (lstBA.length > 0) {
            //                 //Default ตาม BA service
            //                 form.setValue("oBA", res.result?.data[0] || {})
            //                 setBACurrent(res.result?.data[0].value ?? "")
            //             }

            //             if (res.result?.data.length > 0 && res.result?.data[0]?.value) {
            //                 if (Result?.objVOCType) {
            //                     let nVOCTypeID = Result.objVOCType ? parseInt(Result?.objVOCType?.value) : 0
            //                     let nBAID = parseInt(res.result?.data[0]?.value) ?? 0
            //                     AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID, "IsAdd": false }, (res) => {
            //                         ResultAPI(res, null, () => {
            //                             oOptionVOC = { ...oOptionVOC, lstVOCService: res.result?.data || [] }
            //                         })
            //                     });
            //                 }
            //             }
            //         })
            //     });
            // }


            if (Result?.objCustomer && Result?.objCustomer?.value) {
                AxiosGet(`BAService/GetBAVOC`, { "sVOCFormID": Result.sVOCFormID }, (res) => {
                    ResultAPI(res, null, () => {
                        oOptionVOC = { ...oOptionVOC, lstBA: res.result?.data || [] }

                        let lstBA = res.result?.data || [];
                        if (lstBA.length === 1) {
                            form.setValue("oBA", res.result?.data[0] || {})
                            setBACurrent(res.result?.data[0].value ?? "")
                        }
                        else if (lstBA.length > 0) {
                            //Default ตาม BA service
                            form.setValue("oBA", res.result?.data[0] || {})
                            setBACurrent(res.result?.data[0].value ?? "")
                        }

                        if (res.result?.data.length > 0 && res.result?.data[0]?.value) {
                            if (Result?.objVOCType) {
                                let nVOCTypeID = Result.objVOCType ? parseInt(Result?.objVOCType?.value) : 0
                                let nBAID = parseInt(res.result?.data[0]?.value) ?? 0
                                AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID, "IsAdd": false }, (res) => {
                                    ResultAPI(res, null, () => {
                                        oOptionVOC = { ...oOptionVOC, lstVOCService: res.result?.data || [] }
                                    })
                                });
                            }
                        }
                    })
                });
            }
        }

        //#region  New
        await AxiosGet(`BAService/GetBAType`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCType: res.result?.data || [] }
            })
        });
        await AxiosGet(`BAService/GetContactType`, {}, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstContactType: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetVOCJobType`, { "IsSuggest": false }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstJobType: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 2 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeResolve: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 3 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeCompliant: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 4 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeRequest: res.result.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 5 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstReqInprogress: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 6 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeResponPerson: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 7 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstResponPerson: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 8 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstOutPTT: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetStatusCreateClassify`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstStatus: res.result?.data || [] }
            })
        });
        //#endregion

        await onSetOption(oOptionVOC);

    }

    const onSetOption = async (paramOption) => {
        setOption(paramOption)
        UnBlockUI();
    }

    const GetDataVOCID = async (sParamVOCFormID) => {
        BlockUI();
        await onSaveFlowRead(sParamVOCFormID);

        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: sParamVOCFormID }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {

                setIsRoleDM(res.IsRoleDM)
                let Result = res?.result?.data
                if (Result != null) {
                    await GetOptiontEditFormVOCAll(Result)
                    // status Id  1

                    setnStatusID(Result.nStatusID)
                    setnSelectAddrType(Result.nSelectAddrType)
                    //1
                    form.setValue("sJobCode", Result.sJobCode)
                    form.setValue("sVOCFormCode", Result.sVOCFormCode)
                    form.setValue("sReferVOCFormCode", Result.oRefVOCCode?.label == null ? null : Result.oRefVOCCode)
                    form.setValue("oCustomer", Result.objCustomer)
                    //แจ้งมาตอนแรกยังไม่มี BA
                    // form.setValue("oBA", Result.objOwnerBA?.label == null ? null : Result.objOwnerBA)

                    form.setValue("oCompany", Result.objCompany?.label == null ? null : Result.objCompany)
                    setsCustomer(Result?.objCustomer?.label ?? "")
                    form.setValue("oAddress", Result.objAddr?.label == null ? null : Result.objAddr)

                    form.setValue("oVOCType", Result.objVOCType?.label == null ? null : Result.objVOCType)
                    form.setValue("oVOCService", Result.objVOCService?.label == null ? null : Result.objVOCService)
                    //Condition show other input
                    form.setValue("sOtherVOCService", Result.sVOCServiceOther ?? null)

                    form.setValue("sDetail", Result.sDetail)
                    form.setValue("oTel", Result.objTel)
                    // form.setValue("sInputTel", Result.sJobCode)
                    setIsCheckTel(Result.IsAllowContact)
                    form.setValue("oNoticeChannel", Result.objContactType?.label == null ? null : Result.objContactType)

                    setIsReferVOC(Result.sRefVOCCode != null)

                    setarrAttachment(Result.lstFormFile)

                    //dIssueDate
                    let dIssueDate = moment(Result.dIssueDate);
                    let dTimeIssue = dIssueDate.format("HH:mm");
                    form.setValue("sDateIssue", dIssueDate)
                    // form.setValue("sTimeIssue", dTimeIssue)
                    form.setValue("sTimeIssue", dIssueDate)
                    form.setValue("sNoticeEmail", Result.IsAllowEmailAlert == true ? "1" : "0")
                    //2
                }

            })
        })
    }

    const onHandleField = async (eventValue, sField) => {
        if (sField === "BA") {
            //กรอง บริษัท
            if (eventValue && eventValue.value) {
                if (form.getValues("oVOCType")) {
                    let nVOCTypeID = form.getValues("oVOCType") ? parseInt(form.getValues("oVOCType").value) : 0
                    let nBAID = parseInt(eventValue.value) ?? 0
                    // AxiosGet(`BAService/GetBAService`, { "nVOCTypeID": nVOCTypeID }, (res) => {
                    AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID, "IsAdd": false }, (res) => {
                        ResultAPI(res, null, () => {
                            setOption({ ...Option, lstVOCService: res.result?.data || [] })
                        })
                    });
                }
            }
        }
        else if (sField === "TypeVOC") {
            //กรอง ปัญหาที่พบ
            if (eventValue && eventValue.value) {
                let nBAID = form.getValues("oBA") ? parseInt(form.getValues("oBA").value) : 0
                let nVOCTypeID = parseInt(eventValue.value) ?? 0
                // AxiosGet(`BAService/GetBAService`, { "nVOCTypeID": nVOCTypeID }, (res) => {
                AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID }, (res) => {
                    ResultAPI(res, null, () => {
                        setOption({ ...Option, lstVOCService: res.result?.data || [] })
                    })
                });
            }
        }
    }
    //#endregion

    //#region  Submit Form
    const onSubmitComplaint = (statusMode = "O") => {
        let sMessage = "คุณต้องการที่จะบันทึกและเปิดใบงานใช่หรือไม่ ?"

        let IsConfirm = true;
        if (form.getValues("oStatus")) {
            sMessage = "คุณต้องการที่จะบันทึกและเปิดใบงานใช่หรือไม่ ?"
            let nStatusIDForm = parseInt(form.getValues("oStatus").value);
            //15 แก้ไขแล้ว  16 ปิดแล้ว
            statusMode = nStatusIDForm === 15 ? "RS" : "C";
            if (nStatusIDForm === 12) {
                statusMode = sResponPerson == "25" ? "O" : "I";
            } else if (nStatusIDForm === 15) {
                statusMode = "RS";

                //เช็คว่าเป็น unit หรือเปล่า ถ้าใช่ให้บังคับกรอกชื่อผู้รับผิดชอบแก้ไข
                if (sResponPerson == "25" && sTypeResponPerson == "22") {
                    IsConfirm = false
                    sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข ประเภทบุคคล"
                    setnAlertCount(0)
                }
                // if (sResponPerson == "25" && sTypeResponPerson == "23" && nAlertCount < 1) {
                //     IsConfirm = false
                //     setnAlertCount(nAlertCount + 1)
                //     sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข, หากไม่ทราบพนักงานที่รับผิดชอบการแก้ไขกรุณาระบุข้อมูลหน่วยงานที่รับผิดชอบ"
                // }

            } else {
                // sMessage = "คุณต้องการที่จะบันทึกและปิดใบงานใช่หรือไม่ ?"
                statusMode = "C";

                //เช็คว่าเป็น unit หรือเปล่า ถ้าใช่ให้บังคับกรอกชื่อผู้รับผิดชอบแก้ไข
                if (sResponPerson == "25" && sTypeResponPerson == "22") {
                    IsConfirm = false
                    sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข ประเภทบุคคล"
                    setnAlertCount(0)
                }
                // if (sResponPerson == "25" && sTypeResponPerson == "23" && nAlertCount < 1) {
                //     IsConfirm = false
                //     setnAlertCount(nAlertCount + 1)
                //     sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข, หากไม่ทราบพนักงานที่รับผิดชอบการแก้ไขกรุณาระบุข้อมูลหน่วยงานที่รับผิดชอบ"
                // }
            }
        }
        if (IsConfirm) {
            let sResponsibleUnitCode = null;
            let sResponsibleUnitName = null;
            let sResponsibleUnitAbbr = null;
            let sResponsibleEmpCode = null;
            let nExternalPTTUnitID = null;
            let sExternalPTTOther = null;

            if (form.getValues("sTypeResponPerson") && form.getValues("sResponPerson")) {
                switch (form.getValues("sTypeResponPerson")) {
                    case "22":  //in GBU
                        switch (form.getValues("sResponPerson")) {
                            case "25":  //unit
                                sResponsibleUnitCode = form.getValues("oAutoUnitInGBU") ? form.getValues("oAutoUnitInGBU").UnitCode : null;
                                sResponsibleUnitName = form.getValues("oAutoUnitInGBU") ? form.getValues("oAutoUnitInGBU").UnitName : null;
                                sResponsibleUnitAbbr = form.getValues("oAutoUnitInGBU") ? form.getValues("oAutoUnitInGBU").UnitAbbr : null;
                                break;
                            case "26":  //Employee
                                sResponsibleEmpCode = form.getValues("oAutoEmpInGBU") ? form.getValues("oAutoEmpInGBU").value : null;
                                break;
                        }
                        break;
                    case "23":  //in PTT
                        switch (form.getValues("sResponPerson")) {
                            case "25":  //unit
                                sResponsibleUnitCode = form.getValues("oAutoUnitInPTT") ? form.getValues("oAutoUnitInPTT").UnitCode : null;
                                sResponsibleUnitName = form.getValues("oAutoUnitInPTT") ? form.getValues("oAutoUnitInPTT").UnitName : null;
                                sResponsibleUnitAbbr = form.getValues("oAutoUnitInPTT") ? form.getValues("oAutoUnitInPTT").UnitAbbr : null;
                                break;
                            case "26":  //Employee
                                sResponsibleEmpCode = form.getValues("oAutoEmpInPTT") ? form.getValues("oAutoEmpInPTT").value : null;
                                break;
                        }
                        break;
                    case "24":  //out PTT
                        nExternalPTTUnitID = form.getValues("oUnitExternalPTT") ? parseInt(form.getValues("oUnitExternalPTT").value) : null;
                        sExternalPTTOther = form.getValues("sExternalPTT") ?? null;
                        break;
                    default:
                        break;
                }
            }

            let param = {
                "sVOCFormID": sVOCFormID,
                "sMode": statusMode,       //O   เปิดใบงาน
                "nJobTypeID": form.getValues("oTypeJobType") ? parseInt(form.getValues("oTypeJobType").value) : null,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
                "cCustomerType": "E",
                "nVOCFormTypeID": 1,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
                "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
                "nCustomerID": form.getValues("oCustomer") ? parseInt(form.getValues("oCustomer").value) : null,
                "sDetail": form.getValues("sDetail") ?? null,
                "nTelID": form.getValues("oTel") ? parseInt(form.getValues("oTel").value) : null,
                "IsAllowContact": IsCheckTel,
                // "nSelectAddrType": isSetMap === true ? 1 : 2,
                "nSelectAddrType": nSelectAddrType,
                "nAddrID": form.getValues("oAddress") ? parseInt(form.getValues("oAddress").value) : null,
                "nContactTypeID": form.getValues("oNoticeChannel") ? parseInt(form.getValues("oNoticeChannel").value) : null,

                "dIssueDate": form.getValues("sDateIssue") && form.getValues("sTimeIssue") ? new Date(moment(form.getValues("sDateIssue")).format("YYYY-MM-DD") + " " + moment(form.getValues("sTimeIssue")).format("HH:mm")) : null,
                "sIssueDate": form.getValues("sDateIssue") && form.getValues("sTimeIssue") ? moment(form.getValues("sDateIssue")).format("DD/MM/YYYY") + " " + moment(form.getValues("sTimeIssue")).format("HH:mm") : null,
                "IsAllowEmailAlert": form.getValues("sNoticeEmail") && form.getValues("sNoticeEmail") === "1" ? true : false,
                "sRefVOCCode": form.getValues("sReferVOCFormCode") ? form.getValues("sReferVOCFormCode").label : null,
                "nOwnerBAID": form.getValues("oBA") ? parseInt(form.getValues("oBA").value) : null,
                "nVOCTypeID": form.getValues("oVOCType") ? parseInt(form.getValues("oVOCType").value) : null,
                "nVOCServiceID": form.getValues("oVOCService") ? parseInt(form.getValues("oVOCService").value) : null,
                "sVOCServiceOther": form.getValues("sOtherVOCService") ?? null,

                "objFormData": {
                    "sVOCFormID": sVOCFormID,
                    "nComplaintIssueTypeID": form.getValues("oTypeResolve") ? parseInt(form.getValues("oTypeResolve").value) : null,
                    "nComplaintIssueSubTypeID": form.getValues("oReqInprogress") ? parseInt(form.getValues("oReqInprogress").value) : null,
                    "sComplaintIssueSubTypeOther": form.getValues("sReqInprogress") ?? null,
                    "nGBUComplaintTypeID": form.getValues("oTypeCompliant") ? parseInt(form.getValues("oTypeCompliant").value) : null,

                    "nRequestTypeID": form.getValues("oTypeRequest") ? parseInt(form.getValues("oTypeRequest").value) : null,
                    "sRequestTypeOther": form.getValues("sRequestTypeOther") ?? null,

                    "nResponsibleTypeID": form.getValues("sTypeResponPerson") ? parseInt(form.getValues("sTypeResponPerson")) : null,
                    "nResponsibleID": form.getValues("sResponPerson") ? parseInt(form.getValues("sResponPerson")) : null,
                    "sResponsibleUnitAbbr": sResponsibleUnitAbbr,
                    "sResponsibleUnitCode": sResponsibleUnitCode,
                    "sResponsibleUnitName": sResponsibleUnitName,

                    "sResponsibleEmpCode": sResponsibleEmpCode,
                    "nExternalPTTUnitID": nExternalPTTUnitID,
                    "sExternalPTTOther": sExternalPTTOther,

                    "nSolutionTypeID": form.getValues("sSolution") ?? null,    //flow
                    "sResloveDetail": form.getValues("sResolveDetail"),     //flow
                    "sPlanDetail": form.getValues("sPlanDetail") ?? null         //flow
                },
                "objFormFile": arrAttachment,
                "objRequestTypeFile": DataRowResolve || [],
                "objLongTermPlanFile": null,

            }
            SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
                BlockUI();
                AxiosPost(`VOC/SaveVOCFormData`, param, (res) => {
                    ResultAPI(res, null, () => {
                        if (res.statusCode === 200) {
                            setIsOpenSnackbar(true);
                            let sHTML = <><p>บันทึกข้อมูลสำเร็จ</p><p>เลขที่ใบงาน: {res?.result?.sJobCode}</p></>
                            setsMessageSnackbar(sHTML)
                            setsSeveritySnackbar("success")
                            BlockUI();
                            setTimeout(() => {
                                UnBlockUI();
                                onGotoBack();
                            }, 2000)
                        }
                        else {
                            setIsOpenSnackbar(true);
                            setsMessageSnackbar(res.Message)
                            setsSeveritySnackbar("warning")
                            UnBlockUI();

                        }
                    })
                }, (err) => {
                    setIsOpenSnackbar(true);
                    setsMessageSnackbar(err.response.data.Message)
                    setsSeveritySnackbar("warning")

                    setTimeout(() => {
                        UnBlockUI();
                        onGotoBack();
                    }, 2000)
                }, null)
            })
        } else {
            SwAlert.Warning(AlertTitleTh.Warning, sMessage, () => {
                setsResponPerson("26")
                form.setValue("oAutoEmpInGBU", null)
                form.setValue("sResponPerson", "26")
            })
        }


    }

    //#endregion

    //#region   For component Resolve
    const onAddResolve2Table = () => {
        let arrResolve = [];
        (DataRowResolve || []).forEach(val => arrResolve.push(Object.assign({}, val)));
        // let Id = arrResolve.length > 0 ? (Math.max.apply(Math, arrResolve.map(function (o) { return o.nRow; }))) + 1 : 1
        let nIDMAX = arrResolve.length > 0 ? (Math.max.apply(Math, arrResolve.map(function (o) { return o.sID; }))) + 1 : 1
        let nRowMAX = arrResolve.length > 0 ? (Math.max.apply(Math, arrResolve.map(function (o) { return o.nRow; }))) + 1 : 1
        arrResolve.push({
            "sID": nIDMAX,
            "nRow": nRowMAX,
            "sFileName": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileName : null,
            "sFileID": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileID : null,
            "sFileType": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileType : null,
            "sFileLink": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileLink : null,
            "sPath": arrFileResolve.length > 0 ? arrFileResolve[0]?.sPath : null,
            "sSysFileName": arrFileResolve.length > 0 ? arrFileResolve[0]?.sSysFileName : null,
            "sNoteID": null,
            "IsNew": true,
            "IsDelete": false
        })
        setDataRowResolve(arrResolve)
        //Add success to clear data
        onClearFileResolve.current(null)
    }

    const onDeleteArrResolve = (itemRow) => {
        let arrResolve = [];
        (DataRowResolve || []).forEach(val => arrResolve.push(Object.assign({}, val)));
        let findindx = arrResolve.findIndex(f => f.nRow == itemRow.nRow);
        if (findindx != -1) {
            arrResolve[findindx].IsDelete = true;
            let arrTotal = arrResolve.filter(f => f.IsDelete == false);
            if (arrTotal.length > 0) {
                let nID = 1;
                arrTotal.forEach(element => {
                    element.nRow = nID;
                    nID++;
                });
            }
            setDataRowResolve(arrTotal)
        }

    }
    //#endregion

    const onGotoBack = () => {
        let sUrl = -1 as any;
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const strMail = urlParams.get("strMail");
        
        if(strMail != null && strMail != "")
        {
            sUrl = "/Backend/HomeBackEnd";
        }
        navigate(sUrl);
    }


    const onGotoLiveChat = async () => {

        //Create nChatID 
        let nChatID = 0;
        await AxiosGet(`VOC/GetCreateChatID`, { "sVOCFormID": sVOCFormID }, (res) => {
            ResultAPI(res, null, () => {
                nChatID = res.nChatID;
            })
        });

        await GotoChat(nChatID);

    }

    const GotoChat = async (nChatID) => {
        let StrUrl = "/Backend/LiveChat";
        navigate(StrUrl,
            {
                state:
                {
                    sVOCFormID: sVOCFormID,
                    nChatID: nChatID
                }
            }
        );
    }


    const JsxBoxChat = () => {
        return (
            <>
                <Grid item xs={6} md={10} xl={12}>
                    <CardBox
                        icon={<AiFillWechat style={{ fontSize: '2.5em', color: '#11c990' }} />}
                        label={"Chat"}
                        subLabel={sCustomer}
                        onClick={() => { onGotoLiveChat() }}
                        classCard={"button-chat"}
                    />
                </Grid>
                <Grid item xs={6} md={12} xl={12}>
                                <CardBox
                                    icon={<ChatRoundedIcon style={{ fontSize: '2em', color: '#237ce0' }} />}
                                    label={"Workflow History"}
                                    onClick={() => { setIsOpenModalWorkFlowHis(true) }}
                                    classCard={"button-wfHis"}
                                    style={{
                                        height : '46px'
                                    }}
                                />
                            </Grid>
            </>
        )
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<BiEdit style={{ fontSize: '1.5em' }} />}
                labal_Head="สร้างใบงาน"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ marginTop: '0' }}>
                <Grid item xs={12} md={sVOCFormID != null && Layout1300 ? 10 : 12}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12}> {/** ข้อมูลข้อร้องเรียน */}
                            <FormProvider {...form}>
                                <CpnDataClassifyVOC
                                    form={form}
                                    header={"ข้อมูลการแจ้งปัญหา"}
                                    arrAttachment={arrAttachment}
                                    setarrAttachment={setarrAttachment}
                                    Option={Option}
                                    onHandleField={onHandleField}
                                    IsCheckTel={IsCheckTel}
                                    IsOtherVOCService={IsOtherVOCService}
                                    setIsOtherVOCService={setIsOtherVOCService}
                                    onClearFile={onClearFile}
                                    sMode={sMode}
                                    BAold={BAold}
                                    setBACurrent={setBACurrent}
                                    UserLoginBA={UserLoginBA}
                                    IsReferVOC={IsReferVOC}
                                />
                            </FormProvider>
                        </Grid>
                        <Grid item xs={12} style={{ display: UserLoginBA.includes(parseInt(form.getValues("oBA")?.value)) ? "" : "none" }}>
                            <FormProvider {...form}>
                                <CpnClassifyIssue
                                    form={form}
                                    Option={Option}
                                    setsTypeClassifyIssue={setsTypeClassifyIssue}
                                    setIsOtherRequest={setIsOtherRequest}
                                    setIsRequireObjInprogress={setIsRequireObjInprogress}
                                    setIsRequireOtherInprogress={setIsRequireOtherInprogress}
                                />
                            </FormProvider>
                        </Grid>

                        {
                            form.getValues("oTypeJobType") && form.getValues("oTypeJobType").value === "1" && UserLoginBA.includes(parseInt(form.getValues("oBA")?.value))
                                ?
                                <>
                                    <Grid item xs={12} >
                                        <FormProvider {...form}>
                                            <CpnTypeRequestComplaint
                                                form={form}
                                                Option={Option}
                                                setIsRequireObjInprogress={setIsRequireObjInprogress}
                                                setIsRequireOtherInprogress={setIsRequireOtherInprogress}
                                            />
                                        </FormProvider>
                                    </Grid>
                                </>
                                :
                                form.getValues("oTypeJobType") && form.getValues("oTypeJobType").value === "2" && UserLoginBA.includes(parseInt(form.getValues("oBA")?.value))
                                    ?
                                    <>
                                        <Grid item xs={12} >
                                            <FormProvider {...form}>
                                                <CpnTypeRequest
                                                    form={form}
                                                    Option={Option}
                                                    IsOtherRequest={IsOtherRequest}
                                                    setIsOtherRequest={setIsOtherRequest}
                                                />
                                            </FormProvider>
                                        </Grid>
                                    </>
                                    : null
                        }
                        {
                            form.getValues("oTypeJobType") && UserLoginBA.includes(parseInt(form.getValues("oBA")?.value))
                                ?
                                <>
                                    <Grid item xs={12} >
                                        <FormProvider {...form}>
                                            <CpnResponPerson
                                                form={form}
                                                schemaObj={schemaObj}
                                                setSchemaObj={setSchemaObj}
                                                Option={Option}
                                                IsRoleDM={false}
                                                IsRoleVP={false}
                                                nStatusID={nStatusID}
                                                sMode={sMode}
                                                sTypeResponPerson={sTypeResponPerson}
                                                setsTypeResponPerson={setsTypeResponPerson}
                                                sResponPerson={sResponPerson}
                                                setsResponPerson={setsResponPerson}
                                                setIsOtherExternalPTT={setIsOtherExternalPTT}
                                            />
                                        </FormProvider>
                                    </Grid>
                                </>
                                :
                                null
                        }
                        <Grid item xs={12} style={{ display: UserLoginBA.includes(parseInt(form.getValues("oBA")?.value)) ? "" : "none" }}>
                            <CpnNote
                                sVOCFormID={sVOCFormID}
                                nStatusID={nStatusID}
                                sMode={sMode}
                            />
                        </Grid>
                        {       //BA admin / super admin skip flow
                            form.getValues("oTypeJobType") && (DataUser.lstRoleUser.includes(2) || DataUser.lstRoleUser.includes(3))
                                ?
                                <Grid item xs={12} >
                                    <FormProvider {...form}>
                                        <CpnStatusVOC
                                            form={form}
                                            Option={Option}
                                            DataRowResolve={DataRowResolve}
                                            arrFileResolve={arrFileResolve}
                                            setarrFileResolve={setarrFileResolve}
                                            onAddResolve2Table={onAddResolve2Table}
                                            onDeleteArrResolve={onDeleteArrResolve}
                                            onClearFileResolve={onClearFileResolve}
                                            nStatusID={nStatusID}
                                            sMode={sMode}
                                            setsStatusForm={setsStatusForm}
                                        />
                                    </FormProvider>
                                </Grid>
                                : null
                        }
                        <Grid item xs={12} >
                            <FormProvider {...form}>
                                <CpnAlertEmail
                                    form={form}
                                    nStatusID={nStatusID}
                                    IsAllowEmailAlert={IsAllowEmailAlert}
                                    sMode={sMode}
                                    sReferFrom={"classify"}
                                />
                            </FormProvider>
                        </Grid>
                        <Grid item xs={12} style={{ display: !Layout1300 ? '' : 'none' }}>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                <Grid item xs={12}>
                                    <VerticalStepper sVOCFormID={sVOCFormID} />
                                </Grid>
                                {JsxBoxChat()}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnSend txt={"บันทึกและเปิดใบงาน"} onClick={form.handleSubmit(() => { onSubmitComplaint() })} />
                                </Grid>
                                <Grid item>
                                    <BtnBack onClick={() => { onGotoBack() }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* Stepper */}
                <Grid item xs={12} md={2} style={{ display: sVOCFormID != null && Layout1300 ? '' : 'none' }}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                            <VerticalStepper sVOCFormID={sVOCFormID} />
                        </Grid>
                        {JsxBoxChat()}
                    </Grid>
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
            <ModalWorkflowHistory
                IsOpen={IsOpenModalWorkFlowHis}
                setIsOpen={setIsOpenModalWorkFlowHis}
                sVOCFormID={sVOCFormID}
            />
        </>
    )
}

export default PageClassifyIssue